import type { User } from "@/shared/types/auth.types";
import type {
  PermissionContext,
  PermissionEvaluation,
} from "./permission.types";

// Permission evaluation service with context-aware checking
export class PermissionEvaluator {
  private static instance: PermissionEvaluator;

  static getInstance(): PermissionEvaluator {
    if (!PermissionEvaluator.instance) {
      PermissionEvaluator.instance = new PermissionEvaluator();
    }
    return PermissionEvaluator.instance;
  }

  // Check if user has a permission with optional context
  canPerformAction(
    userPermissions: string[],
    permission: string,
    _user: User,
    _context?: PermissionContext,
  ): PermissionEvaluation {
    if (userPermissions.includes(permission)) {
      return {
        granted: true,
        reason: "Direct permission match",
        matchedRule: permission,
      };
    }

    return {
      granted: false,
      reason: `Missing required permission: ${permission}`,
    };
  }
}
